<div class="dialog-form">
    <form [formGroup]="packageServiceForm" (ngSubmit)="save()">
        <p-fieldset class="basic">
            <p-header class="article-title">
                <span class="article-title">{{'Básico' | translate}}</span>
            </p-header>

            <div class="form-group single-field">
                <div class="form-control">
                    <label for="name">{{'NAME' | translate}} *</label>
                    <input pInputText name="name" formControlName="name" required maxlength="100">
                </div>
            </div>

            <div class="form-group single-field">
              <div class="form-control">
                  <label for="product">{{'PRODUCT' | translate}} *</label>
                  <p-dropdown placeholder="Selecione..." [filter]="true" [options]="getPackageServiceProducts()"
                      formControlName="product" name="product" optionLabel="label"
                      optionValue="value"
                      [showClear]="true" appendTo="body">
                      <ng-template pTemplate="selectedItem" let-product>
                          <div>{{product.label}}</div>
                      </ng-template>
                      <ng-template pTemplate="item" let-product>
                          <div>{{product.label}}</div>
                      </ng-template>
                  </p-dropdown>
              </div>
          </div>

            <div class="form-group">
                <div class="form-control">
                    <label for="daysDuration">{{'DURATION-DAYS' | translate}} *</label>
                    <input pInputText type="number" name="daysDuration" formControlName="daysDuration" required min="1">
                </div>
                <div class="form-control">
                    <label for="active">{{ 'ACTIVE' | translate }}</label>
                    <p-inputSwitch styleClass="myswitch" formControlName="active" name="active">
                    </p-inputSwitch>
                </div>
            </div>
            <div class="form-group single-field">
                <div class="form-control">
                    <label for="description">{{ 'DESCRIPTION' | translate }}</label>
                    <textarea pInputText maxlength="300" name="description" rows="3" cols="90"
                        formControlName="description"></textarea>
                    <span class="hint">{{packageServiceForm.get('description')?.value?.length || 0}} / 300</span>
                </div>
            </div>

        </p-fieldset>

        <p-fieldset>
            <p-header class="article-title">
                <span class="article-title">{{'PACKAGE-ITEMS' | translate}}</span>
            </p-header>

            <div class="form-group single-field">
                <div class="form-control">
                    <button type="button" class="easymarine secondary" (click)="addPackageItem()">
                        <i class="pi pi-plus"></i> {{'ADD-ITEM' | translate}}
                    </button>
                </div>
            </div>

            <div class="form-group" *ngFor="let item of packageItems; let i = index" style="margin-top: 10px;">
                <div class="form-control">
                    <label>{{'PRODUCT' | translate}} {{i + 1}}</label>
                    <p-dropdown placeholder="Selecione..." [filter]="true" [options]="getAvailableProducts(item)"
                        [(ngModel)]="item.product" [ngModelOptions]="{standalone: true}" optionLabel="label"
                        optionValue="value"
                        [showClear]="true" appendTo="body" [compareWith]="compareSelectItems"
                        (onChange)="onProductChange(item, $event.value)">
                    </p-dropdown>
                </div>
                <div class="form-control">
                    <label>{{'QUANTITY' | translate}}</label>
                    <div style="display: flex; align-items: center; gap: 10px; padding-top: 8px;">
                        <input pInputText type="number" [(ngModel)]="item.quantity"
                            [ngModelOptions]="{standalone: true}" min="1" style="width: 100px;">
                        <i class="pi pi-trash" style="color: #EF5350; cursor: pointer; font-size: 18px;"
                           (click)="removePackageItem(i)" pTooltip="{{'REMOVE-ITEM' | translate}}" tooltipPosition="top"></i>
                    </div>
                </div>
            </div>
        </p-fieldset>

        <div class="form-group align-center">
            <div class="form-control">
                {{'REQUIRED-FIELDS' | translate}}
            </div>
            <div class="buttons">
                <button class="easymarine danger" type="button" (click)="cancel()">
                    {{ 'CANCEL' | translate }}
                </button>
                <button class="easymarine primary" type="submit" [disabled]="loading || packageServiceForm.invalid">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    {{ isEdit ? ('UPDATE' | translate) : ('SAVE' | translate) }}
                </button>
            </div>
        </div>
    </form>
</div>
